import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'kode', 'nama', 'blocking', 'isactive', 'groupprog', 'groupname','newscateg'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/programtv${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.frmmode=='add'){
                    const { data } = await axios.post("programtv", obj);
                    resolve(data);
                } else {
                    const { data } = await axios.put(`programtv/${encodeURIComponent(obj.programkey)}`, obj);
                    resolve(data);
                }
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`programtv/${obj.programkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};